<template>
  <div>
    <PageHeader :title="title" :items="items" />
      <div class="col-md-12">
        <div class="checkout-tabs">
          <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-xl-2 col-sm-3">
            <b-tab active>
              <template v-slot:title>
                <i class="bx bx-question-mark d-block check-nav-icon mt-4 mb-2"></i>
                <p class="fw-bold mb-4">Perguntas Frequentes</p>
              </template>
              <Faqs />
            </b-tab>
            <b-tab title-item-class="mb-2">
              <template v-slot:title>
                <i class="bx bx-support d-block check-nav-icon mt-4 mb-2"></i>
                <p class="fw-bold mb-4">Suporte</p>
              </template>
              <Suporte />
            </b-tab>
            <b-tab>
              <template v-slot:title>
                <i class="bx bx bx-info-circle d-block check-nav-icon mt-4 mb-2"></i>
                <p class="fw-bold mb-4">Informações</p>
              </template>
              <Informativos />
            </b-tab>
          </b-tabs>
        </div>
      </div>
  </div>


</template>

<script>
import PageHeader from "@/components/page-header";
import Faqs from "@/components/suporte/faqs";
import Suporte from "@/components/suporte/suporte";
import Informativos from "@/components/suporte/informativos";
export default {
    components: { 
    PageHeader,
    Faqs,
    Suporte,
    Informativos,
    
  },
  data (){
    return {
      title: "Suporte",
      items: [
        {
          text: "FAQs",
        }
      ],
      campos: [
        {
          key: "area",
          label: "Área",
        },
        {
          key: "nomeContato",
          label: "Nome do Contato",
        },
        {
          key: "telefone",
          label: "Telefone / Whatsapp",
          
        },
        {
          key: "email",
          label: "E-mail",
        },
      ],
      telefones: [
        {
          area: "Gestao de Frota",
          nomeContato: "Roberto Kanashiro",
          telefone: "(44) 98812-8593",
          email: "roberto.kanashiro@unicampo.coop.br"
        },
        {
          area: "Gestor de Projetos Agroquímicas",
          nomeContato: "Alex Eduardo Zaniboni",
          telefone: "(44) 99121-1273",
          email: "alex.zaniboni@unicampo.coop.br"
        },
        {
          area: "Gestor de Projetos Agroquímicas",
          nomeContato: "Carlos Alberto Guerreiro (Kaká)",
          telefone: "(44) 99121-8997",
          email: "carlos.guerreiro@unicampo.coop.br"
        },
        {
          area: "Gestor de Projetos Agroquímicas",
          nomeContato: "Carlos Renato Moreno Macedo",
          telefone: "",
          email: "carlos.macedo@unicampo.coop.br"
        },
        {
          area: "Gestor de Projetos Agroquímicas",
          nomeContato: "João Carlos",
          telefone: "(44) 99136-8078",
          email: "joao.souza@unicampo.coop.br"
        },
        {
          area: "Relacionamento com o Cooperado e Gestao de Frota",
          nomeContato: "Raul de Albuquerque Goetzinger",
          telefone: "(44) 99152-2166",
          email: "raul.goetzinger@unicampo.coop.br"
        },
        {
          area: "Operações e Estratégias",
          nomeContato: "Rafael Ribeiro de Assis",
          telefone: "(44) 99172-1175",
          email: "rafael.assis@unicampo.coop.br"
        },
        {
          area: "Gerente de Gestão",
          nomeContato: "Renata Vanessa Mantovani Jorge",
          telefone: "(44) 98816-9696",
          email: "renata.jorge@unicampo.coop.br"
        },
        {
          area: "Gerente Geral",
          nomeContato: "Jose Willami da Silva",
          telefone: "",
          email: "willami@unicampo.coop.br"
        },
        {
          area: "Gerente Geral",
          nomeContato: "Carlos Renato",
          telefone: "(44) 99117-5273 ",
          email: ""
        },
        {
          area: "Gerente Geral",
          nomeContato: "Alex",
          telefone: "(44) 99121-1273",
          email: ""
        },
      ],
      links: [
        {
          label: "ASTEC - Crédito Rural",
          url:"https://creditorural.apepa.com.br/capa.htm"
        },
        {
          label: "CAR - Cadastro Ambiental Rural",
          url:"https://www.car.gov.br/"
        },
        {
          label: "Certidão Negativa de Débitos",
          url:"http://servicos.receita.fazenda.gov.br/Servicos/certidaointernet/PF/Emitir"
        },
        {
          label: "CREA PR",
          url:"https://www.crea-pr.org.br/ws/"
        },
        {
          label: "EMBRAPA",
          url:"https://www.embrapa.br/"
        },
        {
          label: "Incra",
          url:"https://www.gov.br/incra/pt-br"
        },
        {
          label: "OCB",
          url:"https://www.ocb.org.br/"
        },
        {
          label: "OCEPAR",
          url:"https://www.paranacooperativo.coop.br/ppc/"
        },
        {
          label: "Previsão do tempo",
          url:"https://www.climatempo.com.br/"
        },
        {
          label: "SEAB - PR",
          url:"https://www.agricultura.pr.gov.br/"
        },
        {
          label: "Somos Coop",
          url:"https://www.somos.coop.br/"
        },
        {
          label: "Zoneamento Agrícola",
          url:"https://www.gov.br/agricultura/pt-br/assuntos/riscos-seguro/programa-nacional-de-zoneamento-agricola-de-risco-climatico/portarias"
        },
      ],
      linksInformativos: [
        {
          "label": "Resultado Mensal 10/2023",
          "url": "/uniweb/Content/Documentos/Geral/ResultadoMensal102023.pdf"
        },
        {
          "label": "Ata da Assembleia Geral Ordinária - 2023",
          "url": "/uniweb/Content/Documentos/Geral/AtadaAssembleiaGeralOrdinaria2023.pdf"
        },
        {
          "label": "Ata da Assembleia Geral Ordinária - 2022",
          "url": "/uniweb/Content/Documentos/Geral/AtadaAssembleiaGeralOrdinaria2022.pdf"
        },
        {
          "label": "Ata da Assembleia Geral Ordinária - 2021",
          "url": "/uniweb/Content/Documentos/Geral/AtadaAssembleiaGeralOrdinaria2020.pdf"
        },
        {
          "label": "Ata da Assembléia Geral Extraordinária - 2022",
          "url": "/uniweb/Content/Documentos/Geral/AtadaAssembleiaGeralExtraordinaria2022.pdf"
        },
        {
          "label": "Relatório de Gestão - AGO 2023",
          "url": "/uniweb/Content/Documentos/Geral/RelatoriodeGestaoAGO2023.pdf"
        },
        {
          "label": "Relatório de Atividades e Prestação de Contas - 2022",
          "url": "/uniweb/Content/Documentos/Geral/RelatoriodeAtividadesePrestacaodeContas2022.pdf"
        },
        {
          "label": "Relatório de Atividades e Prestação de Contas - 2021",
          "url": "/uniweb/Content/Documentos/Geral/RelatoriodeAtividadesePrestacaodeContas2021.pdf"
        },
        {
          "label": "Relatório de Atividades e Prestação de Contas - 2020",
          "url": "/uniweb/Content/Documentos/Geral/RelatoriodeAtividadesePrestacaodeContas2020.pdf"
        }
      ],
      linksDocumentos: [
        {
          "label": "Estatuto Social",
          "url": "/uniweb/Content/Documentos/Geral/EstatutoSocial.pdf"
        },
        {
          "label": "Código de Conduta",
          "url": "/uniweb/Content/Documentos/Geral/CODIGODECONDUTA.pdf"
        },
        {
          "label": "Manual do Cooperado",
          "url": "/uniweb/Content/Documentos/Geral/MANUALDOCOOPERADO.pdf"
        },
        {
          "label": "Politica de Brindes e Hospitalidades",
          "url": "/uniweb/Content/Documentos/Geral/PoliticadeBrindeseHospitalidades.pdf"
        },
        {
          "label": "Política Capital Humano Cooperado",
          "url": "/uniweb/Content/Documentos/Geral/PoliticaCapitalHumanoCooperado.pdf"
        },
        {
          "label": "Política Canal de Denúncia",
          "url": "/uniweb/Content/Documentos/Geral/PoliticaCanaldeDenuncia.pdf"
        },
        {
          "label": "Política Capital Humano Colaborador",
          "url": "/uniweb/Content/Documentos/Geral/PoliticaCapitalHumanoColaborador.pdf"
        },
        {
          "label": "Política de Compras",
          "url": "/uniweb/Content/Documentos/Geral/PoliticadeCompras.pdf"
        },
        {
          "label": "Política de Segurança",
          "url": "/uniweb/Content/Documentos/Geral/PoliticadeSeguranca.pdf"
        },
        {
          "label": "Política de Sustentabilidade",
          "url": "/uniweb/Content/Documentos/Geral/PoliticadeSustentabilidade.pdf"
        },
        {
          "label": "Regimento Interno - Projeto ASTEC",
          "url": "/uniweb/Content/Documentos/Geral/RegimentoInternoProjetoASTEC.pdf"
        },
        {
          "label": "Termo de Recebimento do EPI",
          "url": "/uniweb/Content/Documentos/Geral/TermodeRecebimentoEPI.pdf"
        },
        {
          "label": "Modelo de Carta de Desligamento",
          "url": "/uniweb/Content/Documentos/Geral/ModelodeCartadeDesligamento.docx"
        }
      ],
      linksManuais: [
        {
          "label": "ANDEF - Manual de Armazenamento de Produtos Fitossanitários",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeArmazenamentodeProdutosFitossanitarios.pdf"
        },
        {
          "label": "ANDEF - Manual de Destinação Final de Embalagens Vazias de Agrotóxicos",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeSegurancaeSaudedoAplicadordeProdutosFitossanitarios.pdf"
        },
        {
          "label": "ANDEF - Manual de Transporte de Produtos Fitossanitários",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeTransportedeProdutosFitossanitarios.pdf"
        },
        {
          "label": "ANDEF - Manual de Uso Correto de Equipamento de Proteção Individual",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeUsoCorretodeEquipamentosdeProtecaoIndividual.pdf"
        },
        {
          "label": "ANDEF - Manual de Uso Correto e Seguro de Produtos Fitossanitários",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeUsoCorretoeSegurodeProdutosFitossanitarios.pdf"
        },
        {
          "label": "CONFEA - Código de Ética Profissional",
          "url": "/uniweb/Content/Documentos/Geral/CONFEACodigodeEticaProfissional.pdf"
        }
      ],
      linksTransportePerigosos: [
        {
          "label": "Resolução ANTT nº. 3665/2011 Atualiza o Regulamento para o Transporte Rodoviário de Produtos Perigosos",
          "url": "/uniweb/Content/Documentos/Geral/AtualizaRegulaTransporteProdutoPerigosos.pdf"
        },
        {
          "label": "ANDEF - Manual de Destinação Final de Embalagens Vazias de Agrotóxicos",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeSegurancaeSaudedoAplicadordeProdutosFitossanitarios.pdf"
        },
        {
          "label": "ANDEF - Manual de Transporte de Produtos Fitossanitários",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeTransportedeProdutosFitossanitarios.pdf"
        },
        {
          "label": "ANDEF - Manual de Uso Correto de Equipamento de Proteção Individual",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeUsoCorretodeEquipamentosdeProtecaoIndividual.pdf"
        },
        {
          "label": "ANDEF - Manual de Uso Correto e Seguro de Produtos Fitossanitários",
          "url": "/uniweb/Content/Documentos/Geral/ManualdeUsoCorretoeSegurodeProdutosFitossanitarios.pdf"
        },
        {
          "label": "CONFEA - Código de Ética Profissional",
          "url": "/uniweb/Content/Documentos/Geral/CONFEACodigodeEticaProfissional.pdf"
        }
      ],
      linksOutrasInfo: [
        {
          "label": "Documento 19 RCP Bacen",
          "url": "/uniweb/Content/Documentos/Geral/Documento19-RCP-Bacen29-12-2016.docx"
        },
        {
          "label": "Tutorial Geo Mapa Rural - Captura Proagro",
          "url": "/uniweb/Content/Documentos/Geral/TutorialGeoMapaRural-CapturaProagro.pdf"
        }
      ]
    }
  }
}
</script>